module.exports = __webpack_public_path__ + "media/e博视动画3秒循环.c22d8669.mp4";